import { FunctionalComponent, h } from '@stencil/core';
import { RiskRatingData } from '../../_interfaces/fund-card/risk-rating-data';
import { RiskRatingImages } from '../../_interfaces/fund-card/risk-rating-images';
import { RiskRatingImage } from './card-risk-rating-image';
import { testRiskImages } from '../fund-card-api-config';

interface RiskRatingProps {
	riskIndicator: RiskRatingData;
	contentTranslations: {
		nlRiskLabel: string;
	};
	riskImages: RiskRatingImages;
	fundId?: number;
}

export const RiskRating: FunctionalComponent<RiskRatingProps> = ({
	riskIndicator,
	contentTranslations,
	riskImages,
	fundId = 0,
}) => {
	const label = contentTranslations.nlRiskLabel;
	const images = riskImages ? riskImages : testRiskImages;
	const { formattedValue, infoBubble } = riskIndicator?.sriNum;
	const riskRatingInteger = parseInt(formattedValue);
	const tooltipText = infoBubble ? infoBubble : ' ';
	const displayedRating = isNaN(riskRatingInteger)
		? formattedValue
		: riskRatingInteger;
	const tooltipFundId = `ds-tooltip-with-image-${fundId}`;

	return (
		<div class="ds-card-container ds-card-data-container">
			<div class="ds-data-points">
				<div class="ds-left-col">
					<div class="ds-body-s">
						{label}&nbsp;
						<ds-tooltip-with-image id={tooltipFundId} content={tooltipText}>
							<RiskRatingImage rating={formattedValue} images={images} />
						</ds-tooltip-with-image>
					</div>
					<div class="ds-fund-data">{displayedRating}</div>
				</div>
			</div>
		</div>
	);
};
